<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="side-bar" >
    <a :class="{ active: current === 'video' }" href="/publish">视频创作中心</a>
    <a :class="{ active: current === 'story' }" href="/story-publish">文物故事开放平台</a>
  </div> 
</template>
<script>
/*eslint-disable*/
export default {
  data() {
    return {
      userInfo: null,
      pageName: '',
    }
  },
  props: {
    current: ''
  },
  mounted () {
    console.log(this.current)
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.side-bar{
  width: 210px;
  height: 100vh;
  background: #EBEFF2;
  position: fixed;  
  top: 64px;
  z-index: 10;
  padding-top: 30px;
  a{
    display: block;
    width: 210px;
    height: 62px;
    color: #000;
    text-align: center;
    line-height: 62px;
    &.active{
      background: #fff;
      color: #04CBCD;
    }
  }
}
</style>
